import { isSemrush } from '/src/utils/semrush';

const BASE64_PREFIX = 'b64:';

function toBase64Url(value) {
  try {
    const bytes = new TextEncoder().encode(value);
    let binary = '';
    for (const byte of bytes) {
      binary += String.fromCharCode(byte);
    }

    return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  } catch {
    return null;
  }
}

function fromBase64Url(value) {
  try {
    const normalized = value.replace(/-/g, '+').replace(/_/g, '/');
    const paddingLength = (4 - (normalized.length % 4)) % 4;
    const padded = normalized + '='.repeat(paddingLength);
    const binary = atob(padded);
    const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0));

    return new TextDecoder().decode(bytes);
  } catch {
    return null;
  }
}

function looksLikeJsonString(value) {
  if (typeof value !== 'string') return false;

  const trimmed = value.trim();
  if (!trimmed) return false;

  return trimmed.startsWith('{') || trimmed.startsWith('[') || trimmed.startsWith('"');
}

function isMaybeBase64Url(value) {
  return /^[A-Za-z0-9_-]+$/.test(value) && value.length > 3;
}

export function decodeQueryParamValue(value) {
  if (typeof value !== 'string' || value.length === 0) {
    return value;
  }

  if (value.startsWith(BASE64_PREFIX)) {
    const decoded = fromBase64Url(value.slice(BASE64_PREFIX.length));
    return decoded ?? value;
  }

  if (!isMaybeBase64Url(value)) {
    return value;
  }

  const decoded = fromBase64Url(value);
  if (!decoded || !looksLikeJsonString(decoded)) {
    return value;
  }

  return decoded;
}

export function encodeQueryParamValue(value) {
  if (!isSemrush || typeof value !== 'string' || !looksLikeJsonString(value)) {
    return value;
  }

  if (value.startsWith(BASE64_PREFIX)) {
    return value;
  }

  const encoded = toBase64Url(value);
  return encoded ? `${BASE64_PREFIX}${encoded}` : value;
}
